import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BrowserDataApi from '../../utils/browserDataApi';
import BrowserDataStorage from '../../utils/browserDataStorage';
import HighScoreHandler from '../../utils/highScoreHandler';
import Score from '../score/score';
import Game from '../game/game';
import GameEnd from '../game-end/gameEnd';
import VsBadge from '../vs-badge/vsBadge';
import TermActions from '../term-actions/termActions';
import ContentSwapper from '../content-swapper/contentSwapper';


export default class SinglePlayerGame extends Component {

  constructor(props) {
    super(props);

    this.incrementScore = this.incrementScore.bind(this);
    this.storeHighScoreAndEndGame = this.storeHighScoreAndEndGame.bind(this);
    this.storeHighScore = this.storeHighScore.bind(this);
    this.endGame = this.endGame.bind(this);
    this.restartGame = this.restartGame.bind(this);
    this.exitGame = this.exitGame.bind(this);

    this.storageKey = '2mpG6UNKeiQcjF8V7W+zJc8fEjzN6esxt+CTcntAKS4H5DAzAx7CVu8XQoRDDLu0dDVeCOXBLffoY2zyg';
    this.highScoreHandler = new HighScoreHandler(new BrowserDataStorage(new BrowserDataApi()));
    this.gameCount = 0;
    this.adgameFrequency = 1; //1 ad per game
    this.roundTimeSeconds = props.gameMode === 'timed' ? 10 : 0;

    this.state = {
      terms: this.props.terms,
      score: 0,
      roundState: 'initial', 
      showAd: false,
      highscore: this.highScoreHandler.getHighScore(this.storageKey),
      answered: false
    };
  }

  componentDidMount() {
    this.beginNewRound();
  }

  shuffleTerms(terms) {
    for (var j, x, i = terms.length; i; j = parseInt(Math.random() * i, 10), x = terms[--i], terms[i] = terms[j], terms[j] = x);
    console.log('shuffled...' + terms[0].keyword);
    return terms;
  }

  beginNewRound() {
    setTimeout(() => {
      this.setState((prevState, props) => { 
        return {
          terms: this.shuffleTerms(prevState.terms),
          score: 0,
          roundState: 'new',
          showAd: false,
          answered: false
        }
      });
    }, 500);

    if (this.props.gameMode === 'timed') {
      setTimeout(() => {
        this.setState({roundState: 'countdown'});
      }, 1200);
    }
  }

  async incrementScore() {
    this.setState({
      roundState: 'processing',
      answered: true
    });

    await this.runAfterCssAnimationComplete(1200, () => { //Wait for count up css animation of search volume
      this.setState({ roundState: 'win' }); 
    });

    await this.runAfterCssAnimationComplete(2000, () => { //Wait for win badge css animation of vs badge
      this.setState((prevState, props) => ({
        score: prevState.score + 1,
        roundState: 'new',
        answered: false
      }));
    });

    if (this.props.gameMode === 'timed') {
      await this.runAfterCssAnimationComplete(1200, () => { //Wait for VS badge initial animation
        this.setState({roundState: 'countdown'});
      });
    }
  }

  async storeHighScoreAndEndGame() {
    this.gameCount++;
    this.setState({ 
      roundState: 'processing',
      answered: true 
    });
    await this.runAfterCssAnimationComplete(1200, this.storeHighScore);
    await this.runAfterCssAnimationComplete(1200, this.endGame);
  }

  storeHighScore() {
    this.highScoreHandler.setHighScore(this.storageKey, this.state.score);
    this.setState({ roundState: 'loss' });
  }

  endGame() {
    this.trackScore(this.state.score);
    this.setState({ 
      roundState: 'end', 
      showAd: this.shouldShowInterstitialAd(), 
      highscore: this.highScoreHandler.getHighScore(this.storageKey) 
    });
  }

  shouldShowInterstitialAd() {
    if (this.adgameFrequency <= 0) return false;
    return this.gameCount % this.adgameFrequency === 0;
  }

  restartGame() {
    this.trackPlayAgainEvent();
    this.beginNewRound();
  }

  exitGame() {
    this.props.onQuitGame();
  }

  trackScore(score) {
    window.dataLayer.push({
      'playerGameOverScore': score,
      'categoryName': this.props.pack,
      'event': 'playerGameOver'
    });
  }

  trackPlayAgainEvent() {
    window.dataLayer.push({
      'eventAction': 'Click',
      'eventlabel': 'Play again button',
      'eventCategory': 'Game',
      'gametype': this.props.gameMode,
      'event': 'eventPush'
    });
  }

  runAfterCssAnimationComplete(waitTimeMs, callback) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        callback();
        resolve();
      }, waitTimeMs);
    });
  }

  render() {
    return (
      <ContentSwapper swap={this.state.roundState === 'end'}>
        <div className='game-container'>
          <div className='score-bar'>
            <p className='score-bar__score score-bar__score--highscore'>High Score: {this.state.highscore}</p>
            <Score score={this.state.score} label='Score' />
          </div>
          <Game 
            terms={this.state.terms} 
            onIncorrectAnswer={this.storeHighScoreAndEndGame} 
            onCorrectAnswer={this.incrementScore}
            roundState={this.state.roundState}
            answered={this.state.answered}
            actions={<TermActions hidden={this.state.answered === true} />}
            badge={<VsBadge 
              roundState={this.state.roundState} 
              timerStartSeconds={this.roundTimeSeconds} 
              onTimeOut={this.storeHighScoreAndEndGame} />} 
            gameCount={this.gameCount} />
        </div>
        <GameEnd 
          score={this.state.score} 
          playAgainHandler={this.restartGame}
          exitGameHandler={this.exitGame}
          showAd={this.state.showAd} />
      </ContentSwapper>
    );
  }
}

SinglePlayerGame.propTypes = {
  terms: PropTypes.array,
  pack: PropTypes.string, 
  gameMode: PropTypes.string,
  onQuitGame: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/singleplayer-game/singlePlayerGame.js